var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { css, html, LitElement, nothing } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { getSchemes, modeParameters } from "@jtarrio/signals/demod/modes.js";
import { RrWindow, WindowDelegate } from "../../ui/controls/window.js";
import * as Icons from "../../ui/icons.js";
import { BaseStyle } from "../../ui/styles.js";
import "../../ui/controls/frequency-input.js";
import "../../ui/controls/window.js";
let RrMainControls = class RrMainControls extends WindowDelegate(LitElement) {
    constructor() {
        super(...arguments);
        this.inline = false;
        this.showSettings = true;
        this.showHelp = true;
        this.needsReload = false;
        this.playing = false;
        this.scale = 1000;
        this.centerFrequency = 88500000;
        this.tunedFrequency = 88500000;
        this.tuningStep = 1000;
        this.availableSchemes = getSchemes();
        this.scheme = "WBFM";
        this.bandwidth = 150000;
        this.stereo = true;
        this.squelch = 0;
        this.stereoStatus = false;
        this.gain = null;
        this.gainDisabled = false;
        this.savedGain = 0;
    }
    static get styles() {
        return [
            BaseStyle,
            css `
        rr-window {
          right: auto;
          left: 1em;
        }

        .cfgBlock {
          display: inline-flex;
          flex-direction: column;
        }

        #bandwidth {
          width: 9ex;
        }

        #stereoIcon {
          vertical-align: bottom;
          fill: #bbb;
        }

        #stereoIcon.stereo {
          fill: #060;
        }

        #squelch {
          width: 12ex;
        }

        @media (prefers-color-scheme: dark) {
          #stereoIcon {
            fill: #666;
          }

          #stereoIcon.stereo {
            fill: #0b0;
          }
        }

        label[for="centerFrequency"],
        label[for="tunedFrequency"],
        label[for="tuningStep"] {
          width: 16ex;
          display: inline-block;
          text-align: right;
          padding-right: 0.5ex;
        }
      `,
        ];
    }
    render() {
        return html `<rr-window
      label="Controls"
      id="controls"
      class=${this.inline ? "inline" : ""}
      .position=${this.position}
      .fixed=${this.inline}
    >
      ${this.needsReload
            ? html `<button slot="label-left" id="needsReload" @click=${this.onReload}>
            ${Icons.Reload}
          </button>`
            : this.playing
                ? html `<button slot="label-left" id="stop" @click=${this.onStop}>
              ${Icons.Stop}
            </button>`
                : html `<button slot="label-left" id="start" @click=${this.onStart}>
              ${Icons.Play}
            </button>`}
      <button slot="label-right" id="presets" @click=${this.onPresets}>
        ${Icons.Presets}
      </button>
      ${this.showSettings
            ? html `<button
            slot="label-right"
            id="settings"
            @click=${this.onSettings}
          >
            ${Icons.Settings}
          </button>`
            : nothing}
      ${this.showHelp
            ? html `<a slot="label-right" href="help.html" target="_blank"
            ><button id="help">${Icons.Help}</button></a
          >`
            : nothing}
      <div>
        <label for="centerFrequency">Center frequency: </label
        ><rr-frequency-input
          id="centerFrequency"
          .min=${0}
          .max=${1800000000}
          .frequency=${this.centerFrequency}
          .scale=${this.scale}
          .step=${this.tuningStep}
          @change=${this.onCenterFrequencyChange}
          @scale-change=${this.onScaleChange}
        ></rr-frequency-input>
      </div>
      <div>
        <label for="tunedFrequency">Tuned frequency: </label
        ><rr-frequency-input
          id="tunedFrequency"
          min=${0}
          max=${1800000000}
          .frequency=${this.tunedFrequency}
          .scale=${this.scale}
          .step=${this.tuningStep}
          @change=${this.onTunedFrequencyChange}
          @scale-change=${this.onScaleChange}
        ></rr-frequency-input>
      </div>
      <div>
        <label for="tuningStep">Tuning step: </label
        ><input
          id="tuningStep"
          type="number"
          min="1"
          max="500000"
          .value=${String(this.tuningStep)}
          @change=${this.onTuningStepChange}
        />
        Hz
      </div>
      <div>
        <label for="scheme">Modulation: </label>
        <select id="scheme" @change=${this.onModeChange}>
          ${this.availableSchemes.map((k) => html `<option value="${k}" .selected=${this.scheme == k}>
                ${k}
              </option>`)}
        </select>
        <div class="cfgBlock">
          <span .hidden=${!modeParameters(this.scheme).hasBandwidth()}
            ><label for="bandwidth">Bandwidth: </label
            ><input
              type="number"
              id="bandwidth"
              min="0"
              max="20000"
              step="1"
              .value=${String(this.bandwidth)}
              @change=${this.onBandwidthChange} /></span
          ><span .hidden=${!modeParameters(this.scheme).hasStereo()}>
            <label for="stereo">Stereo: </label
            ><input
              type="checkbox"
              id="stereo"
              .checked=${this.stereo}
              @change=${this.onStereoChange}
            />
            <span
              id="stereoIcon"
              class=${this.stereoStatus ? "stereo" : "mono"}
              .hidden=${!modeParameters(this.scheme).hasStereo() ||
            !this.stereo}
              >${Icons.Stereo}</span
            ></span
          ><span .hidden=${!modeParameters(this.scheme).hasSquelch()}>
            <label for="squelch">Squelch: </label
            ><input
              type="range"
              id="squelch"
              min="0"
              max="6"
              step="0.1"
              .value=${String(this.squelch)}
              @input=${this.onSquelchChange}
            />
          </span>
        </div>
      </div>
      <div>
        <label for="gain">Gain: </label
        ><input
          type="range"
          id="gain"
          min="0"
          max="50"
          .value=${this.gain === null
            ? String(this.savedGain)
            : String(this.gain)}
          .disabled=${this.gain === null || this.gainDisabled}
          @input=${this.onGainInput}
        />
        <input
          type="checkbox"
          id="gainAuto"
          .checked=${this.gain === null || this.gainDisabled}
          .disabled=${this.gainDisabled}
          @change=${this.onGainAutoChange}
        />
        <label for="gainAuto">Auto gain</label>
      </div>
    </rr-window>`;
    }
    onStart() {
        this.dispatchEvent(new StartEvent());
    }
    onStop() {
        this.dispatchEvent(new StopEvent());
    }
    onReload() {
        location.reload();
    }
    onPresets() {
        this.dispatchEvent(new PresetsEvent());
    }
    onSettings() {
        this.dispatchEvent(new SettingsEvent());
    }
    onScaleChange(e) {
        let input = e.target;
        this.scale = input.scale;
        this.dispatchEvent(new ScaleChangedEvent());
    }
    onCenterFrequencyChange(e) {
        let input = e.target;
        this.centerFrequency = input.frequency;
        this.dispatchEvent(new CenterFrequencyChangedEvent());
    }
    onTunedFrequencyChange(e) {
        let input = e.target;
        this.tunedFrequency = input.frequency;
        this.dispatchEvent(new TunedFrequencyChangedEvent());
    }
    onTuningStepChange(e) {
        let input = e.target;
        let step = Number(input.value);
        if (isNaN(step)) {
            input.value = String(this.tuningStep);
            return;
        }
        this.tuningStep = step;
        this.dispatchEvent(new TuningStepChangedEvent());
    }
    onModeChange(e) {
        this.scheme = e.target.selectedOptions[0].value;
        this.dispatchEvent(new SchemeChangedEvent());
    }
    onBandwidthChange(e) {
        let target = e.target;
        let value = Number(target.value);
        if (isNaN(value)) {
            target.value = String(this.bandwidth);
            return;
        }
        this.bandwidth = value;
        this.dispatchEvent(new BandwidthChangedEvent());
    }
    onStereoChange(e) {
        let target = e.target;
        this.stereo = target.checked;
        this.dispatchEvent(new StereoChangedEvent());
    }
    onSquelchChange(e) {
        let target = e.target;
        let squelch = Number(target.value);
        if (isNaN(squelch) || squelch < 0) {
            squelch = 0;
            target.value = String(squelch);
        }
        if (squelch > 6) {
            squelch = 6;
            target.value = String(squelch);
        }
        this.squelch = squelch;
        this.dispatchEvent(new SquelchChangedEvent());
    }
    onGainInput(e) {
        let target = e.target;
        let gain = Number(target.value);
        if (isNaN(gain)) {
            target.value = this.gain == null ? "" : String(this.gain);
            return;
        }
        this.gain = gain;
        this.dispatchEvent(new GainChangedEvent());
    }
    onGainAutoChange(e) {
        let target = e.target;
        if (target.checked) {
            if (this.gain != null)
                this.savedGain = this.gain;
            this.gain = null;
        }
        else {
            this.gain = this.savedGain;
        }
        this.dispatchEvent(new GainChangedEvent());
    }
};
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrMainControls.prototype, "inline", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrMainControls.prototype, "showSettings", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrMainControls.prototype, "showHelp", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrMainControls.prototype, "needsReload", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrMainControls.prototype, "playing", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Number)
], RrMainControls.prototype, "scale", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Number)
], RrMainControls.prototype, "centerFrequency", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Number)
], RrMainControls.prototype, "tunedFrequency", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Number)
], RrMainControls.prototype, "tuningStep", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Array)
], RrMainControls.prototype, "availableSchemes", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", String)
], RrMainControls.prototype, "scheme", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Number)
], RrMainControls.prototype, "bandwidth", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrMainControls.prototype, "stereo", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Number)
], RrMainControls.prototype, "squelch", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrMainControls.prototype, "stereoStatus", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Object)
], RrMainControls.prototype, "gain", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrMainControls.prototype, "gainDisabled", void 0);
__decorate([
    state(),
    __metadata("design:type", Number)
], RrMainControls.prototype, "savedGain", void 0);
__decorate([
    query("rr-window"),
    __metadata("design:type", typeof (_a = typeof RrWindow !== "undefined" && RrWindow) === "function" ? _a : Object)
], RrMainControls.prototype, "window", void 0);
RrMainControls = __decorate([
    customElement("rr-main-controls")
], RrMainControls);
export { RrMainControls };
class StartEvent extends Event {
    constructor() {
        super("rr-start", { bubbles: true, composed: true });
    }
}
class StopEvent extends Event {
    constructor() {
        super("rr-stop", { bubbles: true, composed: true });
    }
}
class PresetsEvent extends Event {
    constructor() {
        super("rr-presets", { bubbles: true, composed: true });
    }
}
class SettingsEvent extends Event {
    constructor() {
        super("rr-settings", { bubbles: true, composed: true });
    }
}
class ScaleChangedEvent extends Event {
    constructor() {
        super("rr-scale-changed", { bubbles: true, composed: true });
    }
}
class CenterFrequencyChangedEvent extends Event {
    constructor() {
        super("rr-center-frequency-changed", { bubbles: true, composed: true });
    }
}
class TunedFrequencyChangedEvent extends Event {
    constructor() {
        super("rr-tuned-frequency-changed", { bubbles: true, composed: true });
    }
}
class TuningStepChangedEvent extends Event {
    constructor() {
        super("rr-tuning-step-changed", { bubbles: true, composed: true });
    }
}
class SchemeChangedEvent extends Event {
    constructor() {
        super("rr-scheme-changed", { bubbles: true, composed: true });
    }
}
class BandwidthChangedEvent extends Event {
    constructor() {
        super("rr-bandwidth-changed", { bubbles: true, composed: true });
    }
}
class StereoChangedEvent extends Event {
    constructor() {
        super("rr-stereo-changed", { bubbles: true, composed: true });
    }
}
class SquelchChangedEvent extends Event {
    constructor() {
        super("rr-squelch-changed", { bubbles: true, composed: true });
    }
}
class GainChangedEvent extends Event {
    constructor() {
        super("rr-gain-changed", { bubbles: true, composed: true });
    }
}
